module.exports = __webpack_public_path__ + "assets/img/img252.ce1a0bef.png";